export default __webpack_public_path__ + "static/media/Ventilation.56fe02d9.jpg";